import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { MsalService } from '@azure/msal-angular';
import { authInterceptor } from './auth/auth.interceptor';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
/*
function MSALInstanceFactory(): IPublicClientApplication {
  const platformId = inject(PLATFORM_ID);

  if (!isPlatformBrowser(platformId)) {
    throw new Error('MSAL must be used in the browser.');
  }

  // Delay this call with a safer wrapper
  if (typeof window === 'undefined' || typeof window.crypto?.subtle === 'undefined') {
    throw new Error('window.crypto.subtle not available — browser not ready');
  }

  return new PublicClientApplication(msalConfig);
}
*/

export const appConfig: ApplicationConfig = {
  providers: [
    //provideClientHydration(withEventReplay()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideRouter(appRoutes),
    MsalService
  ],
};
